import { IPageSizeSelectOption } from './types';

export const OPTIONS: IPageSizeSelectOption[] = [
  { name: '10', value: 10 },
  { name: '25', value: 25 },
  { name: '50', value: 50 },
  { name: '100', value: 100 },
];
